module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABPElEQVRIx2O48vJH477XWZueUx0x/P///8/f/3vvfine/oL6RkPA559/l138mL2ZBkZDwOOPv/qPvqWJ0RBw9un3mt2vaGI0EPz6+2/7rc8FW19Q32gIeP/9z/yzH7JpYTQE3Hv3q/PQG4qNXr/+/58/mKb/+///+KNvFTtfkmX0v3//J078r6LyPzj4/+XLWJ3/4/e/Ddc+5W15QbqrX736Lyb2Pz4eV8h8+f216Uq/5HpDobXaBBGq0ffv/3/79v/Zs9gC5N+yB+s1ttoTYyg2o3GAU28vOO8LJ95Qoox+9u1l+qly4bU6pJqLz+gff370XJ8hs9GEDEPxGb3hyQ797a5kG4rd6EsfrvsejKfQUHSjX/94V3iuQWSdLlXMhRr96+/vabcXKmwyp5ahUKN3vzhktsubuoZCEABO+20lvMM9IAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/dj.png
// module id = 810
// module chunks = 0